import produce from 'immer';

import { CATEGORY_TYPES, CategoryActions, CategoryState } from './categoryTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const initialState: CategoryState = {
  apiCategoryRequestState: API_REQUEST_STATE.IDLE,
  apiCategoryRequestError: null,
  apiCategoriesRequestState: API_REQUEST_STATE.IDLE,
  apiCategoriesRequestError: null,
  categoriesTree: [],
  category: {
    name: '',
    iri: '',
    image: null,
    parent: null,
    subcategories: [],
  },
  categories: [],
};

export const categoryReducer = produce((draft: CategoryState, action: CategoryActions) => {
  switch (action.type) {
    case CATEGORY_TYPES.RESET:
      draft.category = initialState.category;
      break;
    case CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_ERROR:
      draft.apiCategoryRequestError = action.payload.apiCategoryRequestError;
      break;
    case CATEGORY_TYPES.SET_API_CATEGORY_REQUEST_STATE:
      draft.apiCategoryRequestState = action.payload.apiCategoryRequestState;
      break;
    case CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_ERROR:
      draft.apiCategoriesRequestError = action.payload.apiCategoriesRequestError;
      break;
    case CATEGORY_TYPES.SET_API_CATEGORIES_REQUEST_STATE:
      draft.apiCategoriesRequestState = action.payload.apiCategoriesRequestState;
      break;
    case CATEGORY_TYPES.GET_ONE_SUCCESS:
      draft.category = action.payload.category;
      break;
    case CATEGORY_TYPES.GET_ALL_SUCCESS:
      draft.categories = action.payload.categories;
      break;
    case CATEGORY_TYPES.GET_TREE_SUCCESS:
      draft.categoriesTree = action.payload.categories;
      break;
  }
}, initialState);
